export default __webpack_public_path__ + "static/media/powered-by.fa5f7fc5.svg";